import { RefreshCw } from "lucide-react";

export const TranscriptPanel = ({ tx, onRefresh }) => (
  <div className="space-y-8" data-testid="admin-transcript">
    <button
      onClick={onRefresh}
      data-testid="transcript-refresh-btn"
      className="label flex items-center gap-1.5 hover:text-zinc-200"
    >
      <RefreshCw size={11} strokeWidth={1.6} /> Refresh
    </button>
    {(tx?.messages || []).map((msg) => (
      <div key={msg.id}>
        <p className="label">
          #{msg.seq} {msg.role} · {msg.created_at?.slice(11, 19)}
          {msg.masked && <span className="ml-3 !text-zinc-300">withheld by subject</span>}
        </p>
        <p
          data-testid={msg.masked ? `transcript-masked-${msg.seq}` : undefined}
          className={`mt-2 whitespace-pre-wrap text-sm leading-relaxed ${
            msg.masked ? "italic text-zinc-600" : "text-zinc-300"
          }`}
        >
          {msg.content}
        </p>
        {msg.state_block && (
          <pre className="thin-scroll mt-3 max-h-64 overflow-auto border border-[var(--line)] bg-[#0a0a0d] p-3 font-data text-[10px] leading-relaxed text-zinc-500">
            {JSON.stringify(msg.state_block, null, 2)}
          </pre>
        )}
      </div>
    ))}
    {(tx?.messages || []).length === 0 && (
      <p className="font-data text-[11px] text-zinc-600">Empty.</p>
    )}
  </div>
);

export default TranscriptPanel;
